export const AUTH_USER = 'AUTHENTICATED'
export const POST_USER = 'POST_USER'
export const LIST_USER = 'LIST_USER'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const GET_TERM_ACCEPTED = 'GET_TERM_ACCEPTED'
export const RESET_USER_STATE = 'RESET_USER_STATE'
export const POST_TERM_ACCEPTED = 'POST_TERM_ACCEPTED'
